import React, { useRef, useState } from "react";
import styles from "./SortBy.module.scss";
import { isPWA } from "@/helpers/generalHelper";
import useMediaQuery from "@/helpers/hooks/useMediaQuery";
import { useSelector } from "react-redux";
import ArrowChevronDown from "@/components/Logos/ArrowChevronDown";
import ArrowChevronUp from "@/components/Logos/ArrowChevronUp";

// Common component for sorting options in PLP
const SortBy = ({ sortOptions, handleOptionsClick, selected, seoData, isFilterBarFixed}) => {
  const sortByWrapper = useRef();
  // State to manage the active sort option
  const [active, setActive] = useState(selected || sortOptions[0]);
  const isMobile = useMediaQuery("(max-width: 767px)");
  // handles dropdown
  const handleDropdown = (item) => {
    // Toggle the dropdown visibility
    let target = sortByWrapper.current;
    target.classList.toggle(`${styles.active}`);
    if (isMobile) {
      document.body.classList.toggle(`sort_open`);
    }
    // If an item is passed, set it as the active sort option
    item.label && setActive(item);
  };
  const accountSidebarOpen = useSelector((state) => state.loginUser.open_account_sidebar);
  const pageName = seoData?.pageTitle || seoData?.header;

  return (
    <div className={`sort-by-txt ${styles.sort_by_wrapper}`} ref={sortByWrapper}>
      <div className={`${styles.sort_by_backdrop}`} onClick={handleDropdown}></div>
      <div
        className={`${styles.sort_by_header} large-md normal-sm small-xs light-md ${isFilterBarFixed ? 'ga-sort-overlay-' + pageName : 'ga-sort-' + pageName}`}
        onClick={handleDropdown}
        id="sort-handle-button-desktop"
      >
        Sort by<span className={`${styles.xs_hide}`}>:</span>
        <div className={`small-md small-sm ${styles.sort__active_cta}`}>
          <span className={`${styles.active__cta_title} ${isFilterBarFixed ? 'ga-sort-overlay-' + pageName : 'ga-sort-' + pageName}`}>{active?.label}</span>
          <div className={`py-1 ${styles.down_arrow}`}>
            <ArrowChevronDown arrowClass={isFilterBarFixed ? 'ga-sort-overlay-' + pageName : 'ga-sort-' + pageName} />
          </div>
        </div>
      </div>
      <div
        className={`${styles.sort_dropdown} ${isPWA() ? styles.pwa_sort_dropdown : ""} ${
          accountSidebarOpen && !isMobile ? "" : "z-index-100"
        }`}
      >
        <div
          className={`${styles.sort_sub_header}`}
          id="sort-handle-button-mobile"
          onClick={handleDropdown}
        >
          <span className="small-xs">Sort by</span>
          <div className={`py-1 ${styles.down_arrow} ${styles.mob_down_arrow}`}>
            <ArrowChevronUp />
          </div>
        </div>
        <ul className={`${styles.sort__dropdonw_wrapper}`} id={`sort-ul-tag`}>
          {sortOptions.map((item) => (
            <li key={item.value} id={`sort-li-${item.value}`}>
              <a
                className={`exclude-pwa-loader x-small-md x-small-sm small-xs ${
                  styles.sort__dropdown_cta
                }${item.isRefined ? ` ${styles.active__cta}` : ""}`}
                onClick={(event) => {
                  handleDropdown(item);
                  event.preventDefault();
                  handleOptionsClick(item);
                }}
              >
                {item.label}
              </a>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};
export default SortBy;
